// import muster from '@dbk/muster';
// import { encode } from 'base-64';

// export default () => muster()
//   .path('app.global.roster.root', ({ res }, { watchValues }) =>

//     watchValues(['auth.sessionId', 'auth.authHeader', 'auth.userId', 'auth.destinationCurrency', 'app.user.selectedPortfolioData', 'app.user.cacheId', 'portfolio.assetClassName',  'auth.langCode'])
//       .map(([sessionId, authHeader, userId, destinationCurrency, portfolioData, cacheId, assetClassName, langCode]) => {
//         const portfolio = portfolioData || {};
//         const portfolioId = portfolio.title;
//         const relId = portfolio.relId;
//         const branchCode = portfolio.branchCode;
//         const metaObj = {
//           sessionId: sessionId,
//           userId,
//           portfolioId,
//           relId,
//           destinationCurrency,
//           branchCode,
//           authHeader,
//           cacheId,
//           assetClassName,
//           langCode
//         }
       
//         const metaData = encode(JSON.stringify(metaObj));
//         return res.value(`roster.ebanking["${metaData.replace(/=/g, '')}"]`);
//       })
//   );

import muster from '@dbk-legacy/muster';
import { encode } from 'base-64';
// import RNRSA from 'react-native-rsa';
// import Settings from '../../../data/settings.json'

// const rsa = new RNRSA();
// rsa.setPublicString(Settings.publicKeyString);
// function getMetaData (key, value) {
//   if (!value) return;
//   window.meta = window.meta || {}
//   if (!window.meta[key]) 
//   window.meta[key] = rsa.encrypt(value)
//   return window.meta[key]
// }

export default () => muster()
  .path('app.global.roster.root', ({ res }, { watchValues }) =>

    watchValues(['auth.sessionId', 'auth.authHeader', 'auth.userId', 'auth.destinationCurrency', 'app.user.selectedPortfolioData', 'app.user.cacheId', 'portfolio.assetClassName',  'auth.langCode', 'auth.channel', 'app.config.branchCode','ui.state.portfolio.genericAssets.assetSortKey','ui.state.portfolio.genericAssets.assetSortAscending', 'portfolio.overallMarketValue.asOfDate'])
      .map(([sessionId, authHeader, userId, destinationCurrency, portfolioData, cacheId, assetClassName, langCode, channel, configBranchCode,assetSortKey,assetSortAscending, asOfDate]) => {
        const portfolio = portfolioData || {};
        const portfolioId = portfolio.title;
        const relId = portfolio.relId;
        const branchCode = portfolio.branchCode;
        // let encryptedAuth
        // if (authHeader) {
        //   const strs = authHeader.split('.')
        //   const jwtmeta = strs[1].substr(0, 5)
        //   encryptedAuth = getMetaData(jwtmeta, jwtmeta)
        //   authHeader = strs[0]+'.'+strs[1].substr(5)+'.'+strs[2]
        // }
        
        const metaObj = {
          sessionId: sessionId,
          // userId: getMetaData('userId', userId),
          userId,
          // portfolioId: getMetaData(portfolioId, portfolioId),
          portfolioId,
          // relId: getMetaData('relId', relId),
          relId,
          destinationCurrency,
          branchCode,
          // authHeader,
          // encryptedAuth,
          cacheId,
          assetClassName,
          langCode,
          channel,
          // Fetching branchCode from config 
          configBranchCode,
          assetSortKey,
          assetSortAscending,
          asOfDate
        }
       
        const metaData = encode(JSON.stringify(metaObj));
        return res.value(`roster.ebanking["${metaData.replace(/=/g, '')}"]`);
      })
  );
